module.exports = __webpack_public_path__ + "fonts/4236b369-2f95-4452-9326-0e51d1087bdc.472f899d.eot";